const AppRouter = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/Views/HomePage.vue")
    },
    {
        path: "/About",
        name: "About",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/AboutUs.vue")
    },
    {
        path: "/matches",
        name: "Matches",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/MatchesPage.vue")
    },
    {
        path: "/ChatPage",
        name: "ChatPage",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/Chatsystem/views/ChatPage.vue")
    },
    {
        path: "/chat/:conversationId",
        name: "Conversation",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/Chatsystem/views/ChatPage.vue")
    },
    {
        path: "/ContactUs",
        name: "ContactUs",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/ContactUs.vue")
    },
    {
        path: "/LoginPage",
        name: "LoginPage",
        
        component: () => import("@/Views/User/LoginPage.vue")
    },
    {
        path: "/SignUpPage",
        name: "SignUpPage",
        component: () => import("@/Views/User/SignUpPage.vue")
    },
    {
        path: "/UserForm",
        name: "UserForm",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/User/UserForm.vue")
    },
    {
        path: "/UserInfo",
        name: "UserInfo",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/User/UserInfo.vue")
    },
    {
        path: "/UserProfile/:id",
        name: "UserProfile",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/User/UserProfile.vue")
    },
    {
        path: "/PaymentPage",
        name: "PaymentPage",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/User/PaymentPage.vue")
    },
    {
        path: "/GetApp",
        name: "Getapp",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/GetApp.vue")
    },
    {
        path: "/Termsofservice",
        name: "TOS",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/TermsOfServ.vue")
    },
    {
        path: "/PrivacyPolicy",
        name: "Privacypolicy",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/PrivacyPOlicy.vue")
    },
    {
        path: "/search",
        name: "search",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/SearchProfile.vue")
    },
    {
        path: "/notification",
        name: "notification",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/NotificationPage.vue")
    }             
]

export default AppRouter;